import { Collapse } from "bootstrap"

class DesignController {
  constructor() {
    this.load()
  }

  load() {
    this.betterStrategySelect()
    this.betterAnnouncementSelect()
    this.betterSignatureSelect()
    this.openAnchorAccordion()
  }

  betterStrategySelect() {
    $(".js-better-strategy-select a").on("click", function (e) {
      e.preventDefault()
      var the_select = $(this).parents(".js-better-strategy-select")
      var main_option = $(".js-selected .content", the_select)
      main_option.html($(this).html())
    })
  }

  betterAnnouncementSelect() {
    $(".js-better-announcement-select a").on("click", function (e) {
      e.preventDefault()
      var the_select = $(this).parents(".js-better-announcement-select")
      var main_option = $(".js-selected .content", the_select)
      var announcement_input = $(".js-announcement-id")
      main_option.html($(this).html())
      announcement_input.val($(this).attr("href"))
    })
  }

  betterSignatureSelect() {
    $(".js-better-signature-select").on("change", function (e) {
      e.preventDefault()
      var the_select = $(this)
      var main_option = $(the_select.find("option:selected")[0])
      console.log(main_option.val())
      var signature_input = $(".js-signature-id")
      signature_input.val(main_option.val())
    })
  }

  openAnchorAccordion() {
    if (window.location.hash) {
      var target = $("body").find(window.location.hash)
      console.log(target)
      if (target.hasClass("collapse")) {
        new Collapse(target).show()
      }
    }
  }
}

export { DesignController }
